import { ProposalType } from '@/controllers/Proposals';
import { selectNewOpportunity } from '@/store/reducers/opportunities/selectors';
import { AppState, ProposalVm } from '@/types';

import { ProposalMetricsState } from './types';

export const selectProposalDetailsData = (state: AppState): ProposalType => {
  return state.proposal.proposal as ProposalType;
};

export const selectProposal = (state: AppState): ProposalVm | null => {
  const opportunity = selectNewOpportunity(state);

  if (!opportunity) {
    return null;
  }

  const { proposals, syncedProposalId } = opportunity;

  return proposals.find(item => item.id === syncedProposalId) ?? null;
};

export const selectProposalSavingStatus = (state: AppState): boolean => {
  return state.proposal.assignmentInProgress;
};

export const selectProposalMetricsData = (state: AppState): ProposalMetricsState => {
  return state.proposalMetrics;
};

export const selectProposalMetricsDates = (state: AppState) => {
  return state.proposalMetricsDates;
};
